/* eslint-disable */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'index.js';
import { apiUrl } from 'App.js';

const isValidCategoryItem = (item) => {
  if (item === 0 || item === null || item === undefined) return false;
  if (typeof item === 'object') {
    const v = item.value;
    return v !== undefined && v !== null && v !== '' && v !== 0;
  }
  return true;
};

const findLastCategoryLevel = (category) =>
  category.filter(isValidCategoryItem).length;

const categoryCachePart = (cate) => {
  if (!cate || cate === 0) {
    return 0;
  }
  if (typeof cate === 'object' && cate.value != null) {
    return cate.value;
  }
  return cate;
};

const buildRankCacheKey = (rootState) => {
  const categorygraph = rootState.categorygraph || {};
  const {
    a_cate1,
    a_cate2,
    a_cate3,
    a_cate4,
    a_cate5,
    a_cate6,
    r_cate1,
    r_cate2,
    r_cate3,
    r_cate4,
    r_cate5,
    y_cate1,
    y_cate2,
    y_cate3,
    y_cate4
  } = categorygraph;
  const { yearMonth } = rootState.currentsection || {};
  const { channel } = rootState.currentchannel || {};
  return [
    channel,
    yearMonth,
    categoryCachePart(a_cate1),
    categoryCachePart(a_cate2),
    categoryCachePart(a_cate3),
    categoryCachePart(a_cate4),
    categoryCachePart(a_cate5),
    categoryCachePart(a_cate6),
    categoryCachePart(r_cate1),
    categoryCachePart(r_cate2),
    categoryCachePart(r_cate3),
    categoryCachePart(r_cate4),
    categoryCachePart(r_cate5),
    categoryCachePart(y_cate1),
    categoryCachePart(y_cate2),
    categoryCachePart(y_cate3),
    categoryCachePart(y_cate4)
  ].join('|');
};

const buildItemDetailCacheKey = (rootState, arg) => {
  const categorygraph = rootState.categorygraph || {};
  const {
    a_cate1,
    a_cate2,
    a_cate3,
    a_cate4,
    a_cate5,
    a_cate6,
    r_cate1,
    r_cate2,
    r_cate3,
    r_cate4,
    r_cate5,
    y_cate1,
    y_cate2,
    y_cate3,
    y_cate4
  } = categorygraph;
  const { yearMonth } = rootState.currentsection || {};
  const { channel } = rootState.currentchannel || {};
  return [
    channel,
    yearMonth,
    arg.asin,
    arg.shopCode || '',
    categoryCachePart(a_cate1),
    categoryCachePart(a_cate2),
    categoryCachePart(a_cate3),
    categoryCachePart(a_cate4),
    categoryCachePart(a_cate5),
    categoryCachePart(a_cate6),
    categoryCachePart(r_cate1),
    categoryCachePart(r_cate2),
    categoryCachePart(r_cate3),
    categoryCachePart(r_cate4),
    categoryCachePart(r_cate5),
    categoryCachePart(y_cate1),
    categoryCachePart(y_cate2),
    categoryCachePart(y_cate3),
    categoryCachePart(y_cate4)
  ].join('|');
};

export const loadItemDetailGraph = (arg) => (dispatch, getState) => {
  const state = getState();
  const cacheKey = buildItemDetailCacheKey(state, arg);
  const cached = state.categoryrank.itemDetailGraphCache[cacheKey];
  if (cached) {
    dispatch(setItemDetailGraphData(cached));
    return;
  }
  dispatch(fetchItemDetailGraph(arg));
};

export const fetchCategoryRankData = createAsyncThunk(
  'category/rank/post',
  async (_, thunkAPI) => {
    const cacheKey = buildRankCacheKey(thunkAPI.getState());
    const cached = thunkAPI.getState().categoryrank.rankCache?.[cacheKey];
    if (cached) {
      return { ...cached, channel: thunkAPI.getState().currentchannel.channel };
    }

    const {
      a_cate1,
      a_cate2,
      a_cate3,
      a_cate4,
      a_cate5,
      a_cate6,
      r_cate1,
      r_cate2,
      r_cate3,
      r_cate4,
      r_cate5,
      y_cate1,
      y_cate2,
      y_cate3,
      y_cate4
    } = thunkAPI.getState().categorygraph;
    const { yearMonth } = thunkAPI.getState().currentsection;
    const { channel } = thunkAPI.getState().currentchannel;
    const { userId } = thunkAPI.getState().user;
    // 最後に非ゼロのカテゴリを見つけ、その位置を階層として計算
    const amazonLevel = findLastCategoryLevel([
      a_cate1,
      a_cate2,
      a_cate3,
      a_cate4,
      a_cate5,
      a_cate6
    ]);
    const rakutenLevel = findLastCategoryLevel([
      r_cate1,
      r_cate2,
      r_cate3,
      r_cate4,
      r_cate5
    ]);
    const yahooLevel = findLastCategoryLevel([y_cate1, y_cate2, y_cate3, y_cate4]);

    // channel に応じてどのカテゴリの level を渡すか決定
    let categoryLevel = 0;
    if (channel === 1) {
      categoryLevel = amazonLevel;
    } else if (channel === 2) {
      categoryLevel = rakutenLevel;
    } else if (channel === 3) {
      categoryLevel = yahooLevel;
    }
    const res = await client.post(
      `${apiUrl}category/rank`,
      {
        amazon_category: [a_cate1, a_cate2, a_cate3, a_cate4, a_cate5, a_cate6],
        rakuten_category: [r_cate1, r_cate2, r_cate3, r_cate4, r_cate5],
        yahoo_category: [y_cate1, y_cate2, y_cate3, y_cate4],
        term: yearMonth,
        channel: channel,
        user_id: userId,
        category_level: categoryLevel
      },
      { signal: thunkAPI.signal }
    );
    return { channel, ...res.data, cacheKey };
  }
);
export const fetchCategoryRisingData = createAsyncThunk(
  'category/rising/post',
  async (_, thunkAPI) => {
    const {
      a_cate1,
      a_cate2,
      a_cate3,
      a_cate4,
      a_cate5,
      a_cate6,
      r_cate1,
      r_cate2,
      r_cate3,
      r_cate4,
      r_cate5,
      y_cate1,
      y_cate2,
      y_cate3,
      y_cate4
    } = thunkAPI.getState().categorygraph;
    const { yearMonth } = thunkAPI.getState().currentsection;
    const { channel } = thunkAPI.getState().currentchannel;
    const { userId } = thunkAPI.getState().user;
    // 最後に非ゼロのカテゴリを見つけ、その位置を階層として計算
    const amazonLevel = findLastCategoryLevel([
      a_cate1,
      a_cate2,
      a_cate3,
      a_cate4,
      a_cate5,
      a_cate6
    ]);
    const rakutenLevel = findLastCategoryLevel([
      r_cate1,
      r_cate2,
      r_cate3,
      r_cate4,
      r_cate5
    ]);
    const yahooLevel = findLastCategoryLevel([y_cate1, y_cate2, y_cate3, y_cate4]);

    // channel に応じてどのカテゴリの level を渡すか決定
    let categoryLevel = 0;
    if (channel === 1) {
      categoryLevel = amazonLevel;
    } else if (channel === 2) {
      categoryLevel = rakutenLevel;
    } else if (channel === 3) {
      categoryLevel = yahooLevel;
    }
    const res = await client.post(`${apiUrl}category/rising`, {
      amazon_category: [a_cate1, a_cate2, a_cate3, a_cate4, a_cate5, a_cate6],
      rakuten_category: [r_cate1, r_cate2, r_cate3, r_cate4, r_cate5],
      yahoo_category: [y_cate1, y_cate2, y_cate3, y_cate4],
      term: yearMonth,
      channel: channel,
      user_id: userId,
      category_level: categoryLevel
    });
    return res.data;
  }
);
export const fetchItemDetailGraph = createAsyncThunk(
  'category/item/post',
  async (arg, thunkAPI) => {
    const rootState = thunkAPI.getState();
    const cacheKey = buildItemDetailCacheKey(rootState, arg);
    const {
      a_cate1,
      a_cate2,
      a_cate3,
      a_cate4,
      a_cate5,
      a_cate6,
      r_cate1,
      r_cate2,
      r_cate3,
      r_cate4,
      r_cate5,
      y_cate1,
      y_cate2,
      y_cate3,
      y_cate4
    } = rootState.categorygraph;
    const { yearMonth } = rootState.currentsection;
    const { channel } = rootState.currentchannel;
    const { userId } = rootState.user;
    const res = await client.post(`${apiUrl}category/item`, {
      amazon_category: [a_cate1, a_cate2, a_cate3, a_cate4, a_cate5, a_cate6],
      rakuten_category: [r_cate1, r_cate2, r_cate3, r_cate4, r_cate5],
      yahoo_category: [y_cate1, y_cate2, y_cate3, y_cate4],
      term: yearMonth,
      channel: channel,
      user_id: userId,
      item_id: arg.asin,
      shop_code: arg.shopCode
    });
    return {
      cacheKey,
      data: res.data
    };
  }
);

const fetchCategoryRankSlice = createSlice({
  name: 'categoryRank',
  initialState: {
    amazon_100items: [],
    rakuten_100items: [],
    yahoo_100items: [],
    amazon_top_5: [],
    rakuten_top_5: [],
    yahoo_top_5: [],
    itemDetail: {
      rank: '',
      img: '',
      shopCode: '',
      asin: '',
      item_name: '',
      price: '',
      unit_sold: '',
      sales: '',
      graphData: []
    },
    itemDetailLoading: false,
    itemDetailDisplay: false,
    itemDetailGraphCache: {},
    rankCache: {},
    isTop5Loading: false
  },
  reducers: {
    setItemDetailDisplayFlag(state, action) {
      return {
        ...state,
        itemDetailDisplay: action.payload
      };
    },
    setItemDetail(state, action) {
      const sameItem =
        state.itemDetail.asin === action.payload.asin
        && state.itemDetail.shopCode === action.payload.shopCode;
      return {
        ...state,
        itemDetail: {
          rank: action.payload.rank,
          img: action.payload.img,
          shopCode: action.payload.shopCode,
          asin: action.payload.asin,
          item_name: action.payload.item_name,
          price: action.payload.price,
          unit_sold: action.payload.unit_sold,
          sales: action.payload.sales,
          graphData: sameItem ? state.itemDetail.graphData : []
        },
        itemDetailLoading: !sameItem
      };
    },
    setItemDetailGraphData(state, action) {
      return {
        ...state,
        itemDetail: {
          ...state.itemDetail,
          graphData: action.payload.graphdata ?? []
        },
        itemDetailLoading: false
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCategoryRankData.fulfilled, (state, action) => {
      const {
        channel,
        amazon_100items,
        rakuten_100items,
        yahoo_100items,
        cacheKey
      } = action.payload;
      const next = { ...state, isLoading: false };
      if (channel === 1 && amazon_100items !== undefined) {
        next.amazon_100items = amazon_100items;
      } else if (channel === 2 && rakuten_100items !== undefined) {
        next.rakuten_100items = rakuten_100items;
      } else if (channel === 3 && yahoo_100items !== undefined) {
        next.yahoo_100items = yahoo_100items;
      }
      if (cacheKey) {
        next.rankCache = {
          ...state.rankCache,
          [cacheKey]: {
            amazon_100items: next.amazon_100items,
            rakuten_100items: next.rakuten_100items,
            yahoo_100items: next.yahoo_100items
          }
        };
      }
      return next;
    });
    builder.addCase(fetchCategoryRankData.pending, (state, action) => {
      return {
        ...state,
        isLoading: true
      };
    });
    builder.addCase(fetchCategoryRankData.rejected, (state, action) => {
      if (action.meta.aborted) {
        return state;
      }
      return {
        ...state,
        isLoading: false
      };
    });
    builder.addCase(fetchCategoryRisingData.fulfilled, (state, action) => {
      return {
        ...state,
        amazon_top_5: action.payload.amazon_top_5,
        rakuten_top_5: action.payload.rakuten_top_5,
        yahoo_top_5: action.payload.yahoo_top_5,
        isTop5Loading: false
      };
    });
    builder.addCase(fetchCategoryRisingData.pending, (state, action) => {
      return {
        ...state,
        isTop5Loading: true
      };
    });
    builder.addCase(fetchCategoryRisingData.rejected, (state, action) => {
      return {
        ...state,
        amazon_top_5: [],
        rakuten_top_5: [],
        yahoo_top_5: [],
        isTop5Loading: false
      };
    });
    builder.addCase(fetchItemDetailGraph.fulfilled, (state, action) => {
      const { cacheKey, data } = action.payload;
      return {
        ...state,
        itemDetailGraphCache: {
          ...state.itemDetailGraphCache,
          [cacheKey]: data
        },
        itemDetail: {
          ...state.itemDetail,
          graphData: data.graphdata
        },
        itemDetailLoading: false
      };
    });
    builder.addCase(fetchItemDetailGraph.pending, (state, action) => {
      return {
        ...state,
        itemDetailLoading: true
      };
    });
    builder.addCase(fetchItemDetailGraph.rejected, (state, action) => {
      return {
        ...state,
        itemDetail: {
          ...state.itemDetail,
          graphData: []
        },
        itemDetailLoading: false
      };
    });
  }
});

export const { setItemDetailDisplayFlag } = fetchCategoryRankSlice.actions;
export const { setItemDetail } = fetchCategoryRankSlice.actions;
export const { setItemDetailGraphData } = fetchCategoryRankSlice.actions;
export const amazon_100items = (state) => state.categoryrank.amazon_100items;
export const rakuten_100items = (state) => state.categoryrank.rakuten_100items;
export const yahoo_100items = (state) => state.categoryrank.yahoo_100items;
export const amazon_top_5 = (state) => state.categoryrank.amazon_top_5;
export const rakuten_top_5 = (state) => state.categoryrank.rakuten_top_5;
export const yahoo_top_5 = (state) => state.categoryrank.yahoo_top_5;
export const categoryRankStatus = (state) => state.categoryrank.isLoading;
export const categoryTop5IsLoading = (state) =>
  state.categoryrank.isTop5Loading;
export const itemDetail = (state) => state.categoryrank.itemDetail;
export const itemDetailLoading = (state) =>
  state.categoryrank.itemDetailLoading;
export const itemDetailDisplay = (state) =>
  state.categoryrank.itemDetailDisplay;

export default fetchCategoryRankSlice.reducer;
